import $ from "jquery";
import "parsleyjs";
import Cookies from 'js-cookie';
const ModalContact = {
    init: () => {
        const $modalContact = document.getElementById("modalContact");
        if ($modalContact === null)
            return;
        ModalContact.prefillForm($modalContact);
        ModalContact.formValidate($modalContact);
    },
    prefillForm: (modal) => {
        const form = modal.querySelector(".form");
        let isCookieExist = false;
        let formDataContact = {
            name: '',
            email: '',
            companyName: '',
            telephone: '',
            country: '',
        };
        try {
            const formDataContactCookie = Cookies.get('_BD_FORM_DATA_CONTACT');
            formDataContact = JSON.parse(formDataContactCookie);
            isCookieExist = true;
        }
        catch (err) {
            // console.error('_BD_FORM_DATA_CONTACT Cookie not found');
        }
        if (isCookieExist) {
            const inputName = form.querySelector('[name="name"]');
            const inputEmail = form.querySelector('[name="email"]');
            const inputCompanyName = form.querySelector('[name="company_name"]');
            const inputTelephone = form.querySelector('[name="contact_no"]');
            const selectCountry = form.querySelector('[name="country"]');
            inputName.value = formDataContact.name;
            inputEmail.value = formDataContact.email;
            inputCompanyName.value = formDataContact.companyName;
            inputTelephone.value = formDataContact.telephone;
            selectCountry.value = formDataContact.country;
            inputName.classList.add('focus');
            inputEmail.classList.add('focus');
            inputCompanyName.classList.add('focus');
            inputTelephone.classList.add('focus');
            $(selectCountry).trigger('change');
        }
        // const alert = modal.querySelector('.alert');
        // if (alert) { modal.querySelector('.alert').remove(); }
    },
    formValidate: (modal) => {
        const form = modal.querySelector(".form");
        form.addEventListener('submit', (event) => {
            const inputName = form.querySelector('[name="name"]');
            const inputEmail = form.querySelector('[name="email"]');
            const inputCompanyName = form.querySelector('[name="company_name"]');
            const inputTelephone = form.querySelector('[name="contact_no"]');
            const selectCountry = form.querySelector('[name="country"]');
            const formDataContact = {
                name: inputName.value,
                email: inputEmail.value,
                companyName: inputCompanyName.value,
                telephone: inputTelephone.value,
                country: selectCountry.value,
            };
            if ($(form).parsley().isValid()) {
                Cookies.set('_BD_FORM_DATA_CONTACT', JSON.stringify(formDataContact), { expires: 30 });
            }
            event.preventDefault();
        });
    },
};
export default ModalContact;
